import HeroSectionWithRotatedImage from '@composites/HeroSectionWithRotatedImage';
import LegalContent from './components/LegalContent';
import { useTranslation } from 'react-i18next';
import { MetaTags } from '@components/MetaTags';
import { useLocation } from 'react-router-dom';
const TermsAndConditionsPage = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const slug = pathname.split('/').filter(Boolean).pop() || '';

  return (
    <>
      <MetaTags
        title={`we.CONECT Global Leaders Group ${slug?.split('-')?.join(' ')}`}
        description={`we.CONECT Global Leaders Group ${slug?.split('-')?.join(' ')}`}
        keywords={`we.CONECT, ${slug?.split('-')?.join(', ')}`}
        image={`${window.location.origin}/1fdb62e88471bd6a3207.svg`}
        url={window.location.href}
        twitterCardType="summary"
        type="website"
      />
      <HeroSectionWithRotatedImage
        backgroundImageURL={
          'https://media.we-conect.com/images/website/agb_1.jpg'
        }
        label={t('terms-and-conditions-page-title')}
        titleStart={t('terms-and-conditions-page-subtitle')}
        titleBlue={'we.CONECT'}
        titleEnd={'Global Leaders GmbH'}
        buttonText={t('terms-and-conditions-page-button-1')}
        buttonText2={t('terms-and-conditions-page-button-2')}
        buttonScrollTo={t('terms-and-conditions-page-scroll-to-1')}
        button2ScrollTo={t('terms-and-conditions-page-scroll-to-2')}
      />
      <LegalContent />
    </>
  );
};

export default TermsAndConditionsPage;
